import { ActivityHeaderSectionLayout } from "../../layer31";
import { Box } from "@mui/material";
import Image from "../../../../assets/handWave.png";
import { useAppSelector } from "utils/redux/hooks";
import { selectCurrentUserInfo } from "app/containers/Global/slice";
import { useGetCriticalIssuesQuery } from "app/containers/TeamsTab/teamsCheckInApi";
import { getS } from "utils/helperFunctions";

export const CalendarActivityHeaderSection = () => {
  const loggedInUser = useAppSelector(selectCurrentUserInfo);
  const { data: issues = [] } = useGetCriticalIssuesQuery({
    showDismissed: false,
  });

  const subtitle =
    issues.length === 0
      ? "You're all caught up this week!"
      : `Let's get you going on the ${issues.length} item${getS(
          issues.length
        )} due this week.`;

  return (
    <ActivityHeaderSectionLayout
      title={`Welcome back, ${loggedInUser?.firstName || "User"}!`}
      icon={
        <Box
          component="img"
          sx={{
            mixBlendMode: "darken",
          }}
          src={Image}
        />
      }
      subtitle={subtitle}
    />
  );
};
